import { z } from "zod";

export const listingSummaryHydrationContract = z
    .object({
        birthday: z.coerce.date().optional(),
        availableAt: z.coerce.date(),
    })
    .loose();
